/*
 * Find Your Scent — the standalone quiz page.
 *
 * Built for cold ad traffic: someone who has never heard of Pikutin lands here,
 * answers six short questions, and leaves with one bottle picked for them and a
 * reason they can repeat to themselves.
 *
 * Two of the six questions do not score a scent. Q5 (where you spend the day)
 * drives the wear tip, and Q6 (who it is for) picks which offer to close on.
 * They exist because a quiz that only sorts you into a bucket feels like a
 * gimmick; one that tells you something you did not know feels like advice.
 *
 * Every screen is rendered from JS into a single mount point, so the page
 * template stays a few lines instead of a wall of escaped HTML.
 */
(function () {
  'use strict';

  var MOUNT = document.getElementById('pkScentQuiz');
  if (!MOUNT) return;

  var PRODUCTS = window.PK_QUIZ_PRODUCTS || {};

  /* Copy is kept in the same voice as each product page so the quiz never
     promises a scent the PDP then describes differently. */
  var SCENTS = {
    og: {
      handle: 'pikutin-og', name: 'Pikutin OG', tag: 'For everyday plans',
      line: 'Fresh. Relaxed. Effortless.',
      notes: 'Orange · Mint · Ginger · Green herbs · Clean musk',
      blurb: 'The one you reach for without thinking. Clean and easy. It never feels like too much.'
    },
    sputing: {
      handle: 'pikutin-sputing', name: 'Sputing', tag: 'For fresh starts',
      line: 'Clean. Crisp. Ready.',
      notes: 'Green apple · Fresh laundry · Ginger · Bergamot · Clean base',
      blurb: 'Smells like a shirt straight off the line. Safe for work, school, anywhere you need to look after yourself.'
    },
    harabas: {
      handle: 'harabas', name: 'Harabas', tag: 'For nights out',
      line: 'Dark. Warm. Low-key.',
      notes: 'Creamy woods · Smoke · Warm spice · Soft leather · Amber',
      blurb: 'Warm and a little smoky. It does not shout. People just end up standing closer.'
    },
    habulin: {
      handle: 'habulin', name: 'Habulin', tag: 'For date night',
      line: 'Sweet. Warm. Memorable.',
      notes: 'Caramel · Jasmine · Amber · Saffron · Soft woods',
      blurb: 'Sweet but grown-up. This is the one people remember the next day.'
    },
    padrino: {
      handle: 'pikutin-padrino', name: 'Padrino', tag: 'For big moments',
      line: 'Polished. Confident. Presentable.',
      notes: 'Pineapple · Apple · Berries · Bergamot · Smoky birch · Woods',
      blurb: 'Bright at first, deeper as the day goes. For the days you want to look like you have it handled.'
    }
  };

  var ORDER = ['og', 'sputing', 'harabas', 'habulin', 'padrino'];

  /* Q3 carries double weight: what someone wants to SMELL like predicts the
     match far better than where they happen to be going. */
  var QUESTIONS = [
    {
      key: 'where',
      q: 'Where do you go most this week?',
      help: 'Pick the one that happens most often.',
      options: [
        { label: 'Work or school, almost every day', score: { sputing: 3, og: 1 } },
        { label: 'Errands, coffee runs, around town',  score: { og: 3, sputing: 1 } },
        { label: 'Nights out: drinks, parties, drives', score: { harabas: 3, habulin: 1 } },
        { label: 'Dates and dinners for two',          score: { habulin: 3, harabas: 1 } },
        { label: 'Big days: meetings, events, celebrations', score: { padrino: 3, harabas: 1 } }
      ]
    },
    {
      key: 'say',
      q: 'What do you want people to say?',
      help: 'When they get close enough to smell you.',
      options: [
        { label: '“You smell so clean.”',            score: { sputing: 3, og: 1 } },
        { label: '“You smell fresh.”',               score: { og: 3, sputing: 1 } },
        { label: '“You smell expensive.”',           score: { padrino: 3, harabas: 1 } },
        { label: '“You smell sweet. I like it.”',   score: { habulin: 3, padrino: 1 } },
        { label: '“There is something about you.”',  score: { harabas: 3, habulin: 1 } }
      ]
    },
    {
      key: 'smell',
      q: 'Which one smells best to you?',
      help: 'Trust your gut here. This one counts the most.',
      options: [
        { label: 'Orange and mint, like a cold drink', score: { og: 6, sputing: 2 } },
        { label: 'Fresh laundry and green apple',      score: { sputing: 6, og: 2 } },
        { label: 'Wood and a bit of smoke',            score: { harabas: 6, padrino: 2 } },
        { label: 'Caramel and flowers',                score: { habulin: 6, harabas: 2 } },
        { label: 'Pineapple and berries',              score: { padrino: 6, habulin: 2 } }
      ]
    },
    {
      key: 'when',
      q: 'When do you usually spray?',
      options: [
        { label: 'Morning, before I leave the house', score: { og: 2, sputing: 2 } },
        { label: 'All day, I bring it with me',      score: { sputing: 2, og: 1 } },
        { label: 'Evening, before I go out',          score: { harabas: 2, habulin: 2 } },
        { label: 'Only on special days',              score: { padrino: 2, habulin: 1 } }
      ]
    },
    {
      /* No scoring. This decides the wear tip — the part people screenshot. */
      key: 'heat',
      q: 'Where are you most of the day?',
      help: 'This changes how you should spray it.',
      options: [
        { label: 'Mostly in aircon', tip: 'Aircon makes scent last longer. Three sprays is plenty: two on the neck, one behind the ears. More than that and it becomes too much in a closed room.' },
        { label: 'Mostly outside, hot and humid', tip: 'Heat burns scent off faster. Use four to five sprays and hit your shirt collar too. Cloth holds it far longer than skin does. Never rub it in; that kills it.' },
        { label: 'A bit of both', tip: 'Spray three in the morning, keep the bottle in your bag, then add one or two before your evening plans. That is the whole trick.' }
      ]
    },
    {
      key: 'who',
      q: 'Who is this for?',
      options: [
        { label: 'For me',                 close: 'one' },
        { label: 'A gift for someone',     close: 'gift' },
        { label: 'For me and someone else', close: 'two' }
      ]
    }
  ];

  var answers = [];
  var step = 0;
  var unlocked = false;   /* set once the email step is cleared */

  var OFFER = window.PK_QUIZ_OFFER || { code: 'SCENT10', percent: 10 };

  function peso(cents) {
    return '₱' + (cents / 100).toLocaleString('en-PH', { maximumFractionDigits: 0 });
  }

  function el(html) {
    var d = document.createElement('div');
    d.innerHTML = html.trim();
    return d.firstChild;
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /* ---------------------------------------------------------------- intro */

  function renderIntro() {
    MOUNT.innerHTML = '';
    MOUNT.appendChild(el(
      '<section class="pkq pkq--intro">' +
        '<p class="pkq__eyebrow">6 questions · about a minute</p>' +
        /* No brand name in the headline. This page is the first thing cold ad
           traffic sees, and "Which Pikutin is yours?" only lands on someone who
           already knows what a Pikutin is. Lead with what they want to know
           about themselves; the brand is in the header and on the result. */
        '<h1 class="pkq__title">What should<br>you smell like?</h1>' +
        '<p class="pkq__lede">Answer six quick questions. We will match you to one perfume that fits ' +
          'the way you actually live, and tell you how to wear it so it lasts.</p>' +
        '<button class="pkq__cta" type="button" data-start>Start</button>' +
        '<p class="pkq__fine">Cash on delivery. Free shipping nationwide.</p>' +
      '</section>'
    ));
  }

  /* ------------------------------------------------------------- question */

  function renderStep() {
    var Q = QUESTIONS[step];
    var pct = Math.round((step / QUESTIONS.length) * 100);

    var opts = Q.options.map(function (o, i) {
      var picked = answers[step] === i ? ' is-picked' : '';
      return '<button class="pkq__opt' + picked + '" type="button" data-pick="' + i + '">' +
               '<span class="pkq__optMark" aria-hidden="true"></span>' +
               '<span class="pkq__optText">' + o.label + '</span>' +
             '</button>';
    }).join('');

    MOUNT.innerHTML = '';
    MOUNT.appendChild(el(
      '<section class="pkq pkq--step">' +
        '<div class="pkq__bar"><span class="pkq__barFill" style="width:' + pct + '%"></span></div>' +
        '<p class="pkq__count">Question ' + (step + 1) + ' of ' + QUESTIONS.length + '</p>' +
        '<h2 class="pkq__q">' + Q.q + '</h2>' +
        (Q.help ? '<p class="pkq__help">' + Q.help + '</p>' : '') +
        '<div class="pkq__opts">' + opts + '</div>' +
        (step > 0 ? '<button class="pkq__back" type="button" data-back>Back</button>' : '') +
      '</section>'
    ));

    var first = MOUNT.querySelector('.pkq__opt');
    if (first && step > 0) first.focus({ preventScroll: true });
  }

  /* ----------------------------------------------------------- email gate */

  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim());
  }

  /* The matched scent rides along as a customer tag, so the list can later be
     mailed by what each person actually wants rather than as one blob. */
  function subscribe(email) {
    var top = SCENTS[ranked()[0].key];
    var body = new URLSearchParams();
    body.append('form_type', 'customer');
    body.append('utf8', '\u2713');
    body.append('contact[email]', email);
    body.append('contact[tags]', 'newsletter,scent-quiz,match-' + top.handle);

    return fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    });
  }

  function renderEmail() {
    MOUNT.innerHTML = '';
    MOUNT.appendChild(el(
      '<section class="pkq pkq--gate">' +
        '<div class="pkq__bar"><span class="pkq__barFill" style="width:100%"></span></div>' +
        '<p class="pkq__count">Last step</p>' +
        '<h2 class="pkq__q">Your match is ready</h2>' +
        '<p class="pkq__help">Enter your email to see it, and to claim <b>' + OFFER.percent +
          '% off</b> your order, on top of any bundle price.</p>' +
        '<form class="pkq__form" novalidate>' +
          '<label class="pkq__label" for="pkqEmail">Email address</label>' +
          '<input class="pkq__input" id="pkqEmail" type="email" name="email" inputmode="email" ' +
            'autocomplete="email" placeholder="juan@email.com" required>' +
          '<p class="pkq__err" data-err hidden>Please enter a valid email address.</p>' +
          '<button class="pkq__cta" type="submit">Claim 10% and show my match</button>' +
        '</form>' +
        '<button class="pkq__skip" type="button" data-skip>No thanks, just show my match</button>' +
        '<p class="pkq__fine">We will send new scents and offers now and then. ' +
          'You can unsubscribe any time.</p>' +
      '</section>'
    ));
    var input = MOUNT.querySelector('#pkqEmail');
    if (input) input.focus({ preventScroll: true });
  }

  /* --------------------------------------------------------------- result */

  function tally() {
    var s = {};
    ORDER.forEach(function (k) { s[k] = 0; });

    QUESTIONS.forEach(function (Q, qi) {
      var pick = Q.options[answers[qi]];
      if (!pick || !pick.score) return;
      Object.keys(pick.score).forEach(function (k) { s[k] += pick.score[k]; });
    });
    return s;
  }

  function ranked() {
    var s = tally();
    var smellPick = QUESTIONS[2].options[answers[2]];
    var smellFav = smellPick ? Object.keys(smellPick.score)[0] : null;

    return ORDER.slice().sort(function (a, b) {
      if (s[b] !== s[a]) return s[b] - s[a];
      /* A tie goes to whatever they said they wanted to smell like. */
      if (a === smellFav) return -1;
      if (b === smellFav) return 1;
      return 0;
    }).map(function (k) { return { key: k, score: s[k] }; });
  }

  function reasons() {
    var out = [];
    var where = QUESTIONS[0].options[answers[0]];
    var say = QUESTIONS[1].options[answers[1]];
    var smell = QUESTIONS[2].options[answers[2]];
    if (smell) out.push('You picked <b>' + smell.label.toLowerCase() + '</b>.');
    if (where) out.push('Your week is mostly <b>' + where.label.toLowerCase() + '</b>.');
    if (say) out.push('You want to hear <b>' + say.label + '</b>');
    return out;
  }

  function renderResult() {
    var rank = ranked();
    var top = rank[0], second = rank[1];
    var best = SCENTS[top.key], alt = SCENTS[second.key];
    var max = rank[0].score || 1;

    var tip = (QUESTIONS[4].options[answers[4]] || {}).tip || '';
    var close = (QUESTIONS[5].options[answers[5]] || {}).close || 'one';

    var bestP = PRODUCTS[best.handle] || {};
    var altP = PRODUCTS[alt.handle] || {};
    var setP = PRODUCTS['discovery-set'];

    var bars = rank.map(function (r) {
      var sc = SCENTS[r.key];
      var pct = Math.max(12, Math.round((r.score / max) * 100));
      return '<a class="pkq__bar-row' + (r.key === top.key ? ' is-top' : '') + '" href="' +
               ((PRODUCTS[sc.handle] || {}).url || '#') + '">' +
               '<span class="pkq__bar-name">' + sc.name + '</span>' +
               /* Width travels as a custom property: the stylesheet holds the bar at
                  0 with !important so it can animate in, and an inline width would
                  lose that fight. */
               '<span class="pkq__bar-track"><span class="pkq__bar-fill" style="--pkq-w:' + pct + '%"></span></span>' +
               '<span class="pkq__bar-pct">' + pct + '%</span>' +
             '</a>';
    }).join('');

    var offer = '';
    if (close === 'two' && altP.id) {
      offer =
        '<div class="pkq__offer">' +
          '<p class="pkq__offer-head">Buying for two?</p>' +
          '<p class="pkq__offer-body">Take <b>' + best.name + '</b> and <b>' + alt.name + '</b> together for ' +
            '<b>₱1,599</b> instead of ₱1,776. You save ₱177.</p>' +
          '<button class="pkq__cta pkq__cta--ghost" type="button" data-add-two>Add both to cart</button>' +
        '</div>';
    } else if (close === 'gift') {
      offer =
        '<div class="pkq__offer">' +
          '<p class="pkq__offer-head">Not sure they will like it?</p>' +
          '<p class="pkq__offer-body">Three bottles is <b>₱2,149</b> and comes with a <b>free 10ml</b>. ' +
            'Enough to keep one and still give two away.' +
            (setP ? ' Or start them on the <a href="' + setP.url + '">Discovery Set</a> at ' + peso(setP.price) + '.' : '') +
          '</p>' +
        '</div>';
    } else {
      offer =
        '<div class="pkq__offer">' +
          '<p class="pkq__offer-head">Want to try more than one?</p>' +
          '<p class="pkq__offer-body">Two bottles is <b>₱1,599</b>. Three is <b>₱2,149</b> with a ' +
            '<b>free 10ml</b>. Mix and match any scent.' +
            (setP ? ' Or try four 10ml vials first with the <a href="' + setP.url + '">Discovery Set</a>.' : '') +
          '</p>' +
        '</div>';
    }

    MOUNT.innerHTML = '';
    MOUNT.appendChild(el(
      '<section class="pkq pkq--result">' +
        /* Someone who skipped is not shut out. They see the match first, which
           is the moment they most want the bottle, and the offer is still
           there to take — often a better trade than the gate itself. */
        (unlocked ?
          '<div class="pkq__code">' +
            '<p class="pkq__code-head">' + OFFER.percent + '% off is yours</p>' +
            '<p class="pkq__code-val">' + OFFER.code + '</p>' +
            '<p class="pkq__code-note">Already applied to your cart. Screenshot this in case you check out later.</p>' +
          '</div>'
        :
          '<div class="pkq__claim">' +
            '<p class="pkq__claim-head">Still want ' + OFFER.percent + '% off?</p>' +
            '<p class="pkq__claim-note">Drop your email and the code goes straight onto your cart.</p>' +
            '<form class="pkq__form pkq__form--inline" novalidate>' +
              '<label class="pkq__label sr-only" for="pkqEmail">Email address</label>' +
              '<input class="pkq__input" id="pkqEmail" type="email" inputmode="email" ' +
                'autocomplete="email" placeholder="juan@email.com" required>' +
              '<p class="pkq__err" data-err hidden>Please enter a valid email address.</p>' +
              '<button class="pkq__cta" type="submit">Claim ' + OFFER.percent + '%</button>' +
            '</form>' +
          '</div>') +
        '<p class="pkq__eyebrow">Your match</p>' +
        '<h2 class="pkq__name">' + best.name + '</h2>' +
        '<p class="pkq__tagline">' + best.tag + ' · ' + best.line + '</p>' +

        (bestP.image ? '<img class="pkq__shot" src="' + bestP.image + '" alt="' + esc(best.name) + '" width="600" height="600">' : '') +

        '<p class="pkq__blurb">' + best.blurb + '</p>' +
        '<p class="pkq__notes">' + best.notes + '</p>' +

        '<div class="pkq__why">' +
          '<p class="pkq__why-head">Why this one</p>' +
          '<ul class="pkq__why-list"><li>' + reasons().join('</li><li>') + '</li></ul>' +
        '</div>' +

        (bestP.id ?
          '<div class="pkq__buy">' +
            '<span class="pkq__price">' + peso(bestP.price) + '</span>' +
            '<button class="pkq__cta" type="button" data-add="' + bestP.id + '">Add to cart</button>' +
          '</div>' +
          '<p class="pkq__fine"><a href="' + bestP.url + '">See the full page for ' + best.name + '</a></p>'
        : '') +

        (tip ? '<div class="pkq__tip"><p class="pkq__tip-head">How to wear it</p><p>' + tip + '</p></div>' : '') +

        '<div class="pkq__ranks">' +
          '<p class="pkq__ranks-head">How the other four scored for you</p>' +
          bars +
          '<p class="pkq__fine">Closest runner-up: <a href="' + (altP.url || '#') + '"><b>' + alt.name + '</b></a>, ' + alt.tag.toLowerCase() + '.</p>' +
        '</div>' +

        offer +

        '<button class="pkq__again" type="button" data-again>Take it again</button>' +
      '</section>'
    ));

    requestAnimationFrame(function () {
      MOUNT.querySelectorAll('.pkq__bar-fill').forEach(function (b) { b.classList.add('is-in'); });
    });
  }

  /* ----------------------------------------------------------------- cart */

  function addToCart(items, btn) {
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () {
        btn.textContent = 'Added. Go to cart';
        btn.disabled = false;
        btn.dataset.done = '1';
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
        alert('Could not add that just now. Please try again.');
      });
  }

  /* --------------------------------------------------------------- events */

  MOUNT.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-start]')) { step = 0; renderStep(); scrollTop(); return; }

    var opt = t.closest('[data-pick]');
    if (opt) {
      answers[step] = +opt.getAttribute('data-pick');
      opt.classList.add('is-picked');
      /* Short pause so the tap registers visually before the screen changes. */
      setTimeout(function () {
        step += 1;
        if (step < QUESTIONS.length) renderStep();
        else if (!unlocked) renderEmail();
        else renderResult();
        scrollTop();
      }, 160);
      return;
    }

    if (t.closest('[data-skip]')) { renderResult(); scrollTop(); return; }
    if (t.closest('[data-back]')) { step = Math.max(0, step - 1); renderStep(); scrollTop(); return; }
    if (t.closest('[data-again]')) { answers = []; step = 0; renderIntro(); scrollTop(); return; }

    var add = t.closest('[data-add]');
    if (add) {
      if (add.dataset.done) { location.href = '/cart'; return; }
      addToCart([{ id: +add.getAttribute('data-add'), quantity: 1 }], add);
      return;
    }

    var two = t.closest('[data-add-two]');
    if (two) {
      if (two.dataset.done) { location.href = '/cart'; return; }
      var rank = ranked();
      var a = PRODUCTS[SCENTS[rank[0].key].handle];
      var b = PRODUCTS[SCENTS[rank[1].key].handle];
      if (!a || !b) return;
      addToCart([{ id: a.id, quantity: 1 }, { id: b.id, quantity: 1 }], two);
    }
  });

  MOUNT.addEventListener('submit', function (e) {
    var form = e.target.closest('.pkq__form');
    if (!form) return;
    e.preventDefault();

    var input = form.querySelector('#pkqEmail');
    var err = form.querySelector('[data-err]');
    var btn = form.querySelector('button[type="submit"]');
    var email = (input.value || '').trim();

    if (!validEmail(email)) {
      err.hidden = false;
      input.focus();
      return;
    }
    err.hidden = true;
    btn.disabled = true;
    btn.textContent = 'Checking\u2026';

    /* The result is never held hostage to the network. If the subscribe call
       fails we still show the match — a broken form must not cost the sale. */
    subscribe(email)
      .catch(function () {})
      .then(function () { return applyDiscount(); })
      .catch(function () {})
      .then(function () {
        unlocked = true;
        renderResult();
        scrollTop();
      });
  });

  /* Puts the code on the session now, so it is already sitting in the cart when
     they check out instead of relying on them retyping it. */
  function applyDiscount() {
    if (!OFFER.code) return Promise.resolve();
    return fetch('/discount/' + encodeURIComponent(OFFER.code), { redirect: 'follow' });
  }

  function scrollTop() {
    var top = MOUNT.getBoundingClientRect().top + window.pageYOffset - 12;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  renderIntro();
})();
